export enum BILoginTarget {

    Platform = "Platform",
    Deposit = "Deposit",
    ChangeExpiredPassword = "Change expired password",
    TCSignRequired = "T&C signing required",
    LoginError = "Login error"
}
